<template>
  <div class="padding" :class="classes">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'Padding',
  props: {
    size: {
      type: String,
      required: false,
      default: 'default',
      validator: (value) => ['none', 'small', 'default', 'medium', 'medium-large', 'large', 'extra-large'].includes(value),
    },
    tabletSize: {
      type: String,
      required: false,
      default: null,
      validator: (value) => ['none', 'small', 'default', 'medium', 'medium-large', 'large', 'extra-large', null].includes(value),
    },
    mobileSize: {
      type: String,
      required: false,
      default: null,
      validator: (value) => ['none', 'small', 'default', 'medium', 'medium-large', 'large', 'extra-large', null].includes(value),
    },
    direction: {
      type: String,
      required: false,
      default: 'all',
      // validator: (value) => ['all', 'vertical', 'horizontal', 'top', 'bottom', 'left', 'right'].includes(value),
    },
    row: {
      type: Boolean,
      required: false,
      default: false,
    },
    fullHeight: {
      type: Boolean,
      required: false,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    classes() {
      const classes = [`padding--${this.size} padding--${this.direction}`]

      if (this.mobileSize) {
        classes.push(`padding--mobile-${this.mobileSize}`)
      }
      if (this.tabletSize) {
        classes.push(`padding--tablet-${this.tabletSize}`)
      }
      if (this.row) {
        classes.push('padding--row')
      }
      if (this.fullHeight) {
        classes.push('padding--full-height')
      }
      if (this.fullWidth) {
        classes.push('padding--full-width')
      }

      return classes.join(' ')
    },
  },
}
</script>
